import * as React from "react";
import type { SVGProps } from "react";
const SvgKuwait = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 0h1280v240H0z"
      style={{
        fill: "#007a3d",
      }}
    />
    <path
      d="M0 240h1280v240H0z"
      style={{
        fill: "#fff",
      }}
    />
    <path
      d="M0 480h1280v240H0z"
      style={{
        fill: "#ce1126",
      }}
    />
    <path d="m0 0 320 240v240L0 720z" />
  </svg>
);
export default SvgKuwait;
